/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VendorWorkspaceApproveLogDto } from '../../models/vendor-workspace-approve-log-dto';

export interface VendorWorkspaceApproveLogControllerFindAll$Params {
}

export function vendorWorkspaceApproveLogControllerFindAll(http: HttpClient, rootUrl: string, params?: VendorWorkspaceApproveLogControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<VendorWorkspaceApproveLogDto>>> {
  const rb = new RequestBuilder(rootUrl, vendorWorkspaceApproveLogControllerFindAll.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<VendorWorkspaceApproveLogDto>>;
    })
  );
}

vendorWorkspaceApproveLogControllerFindAll.PATH = '/api/vendorWorkspaceApproveLog';
